
  var FGR = 0; 
  
  function entsub() {
  if (event && event.which == 13)
    calcratio();
  }
  

  
  function calcratio() {
	sprocketIn = parseFloat(document.gearRatio.inputJSIn.value);
	sprocketOut = parseFloat(document.gearRatio.inputJSOut.value);
	rpm = parseFloat(document.gearRatio.inputEngine.value);
	rearAxle = parseFloat(document.gearRatio.inputAxle.value);
	FGR = parseFloat(document.gearRatio.inputFinalRatio.value);

	FGR = (sprocketIn / rpm * rearAxle / sprocketOut)
	
	document.gearRatio.inputFinalRatio.value = FGR.toFixed(3);	
  }
  

